import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import MaterialsTableFilters from "components/subComponents/MaterialsTableFilters";

import useMaterialsList from "hooks/list/useMaterialsList";

function ElencoMateriali() {
    const materialsListHook = useMaterialsList();

    const { navigateToNewMaterial, alertConfirmHook, dataTableHook } = materialsListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <MaterialsTableFilters materialsListHook={materialsListHook} />

                <DataTableSimple dataTableHook={dataTableHook} />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewMaterial}>
                        Aggiungi Materiale
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoMateriali;
